export const NO_SOUND = 'none'
// Остаётся в public CRM: звук нового заказа не должен пропасть, если бэк не отдал пресет
export const FALLBACK_NEW_ORDER_SOUND_URL = '/sounds/new_order.mp3'
